import auth0 from "auth0-js"
import { navigate } from "gatsby"

const isBrowser = typeof window !== "undefined"

export const authEnabled = () => {
  return process.env.AUTH0_DOMAIN && process.env.AUTH0_CLIENTID && process.env.AUTH0_CALLBACK
}

const tokens = {
  accessToken: false,
  idToken: false,
  expiresAt: false
}

let user = {}

const getParam = (key) => {
  if (isBrowser) {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop)
    })
    return params[key]
  }
}

const debug = () => {
  const debug = getParam("debug")
  return debug
}

export const getAuth = () => {
  if (debug()) console.log("auth.js", "getAuth")
  return isBrowser && authEnabled()
    ? new auth0.WebAuth({
        domain: process.env.AUTH0_DOMAIN,
        clientID: process.env.AUTH0_CLIENTID,
        redirectUri: process.env.AUTH0_CALLBACK,
        responseType: "token id_token",
        scope: "openid profile email"
      })
    : {}
}

export const isAuthenticated = () => {
  if (debug()) console.log("auth.js", "isAuthenticated")
  if (!isBrowser) {
    return
  }
  return sessionStorage.getItem("isLoggedIn") === "true"
}

export const isAuthorized = () => {
  if (debug()) console.log("auth.js", "isAuthorized")
  if (!isBrowser) {
    return
  }
  return true
  // return sessionStorage.getItem("userRoles").includes("client")
}

export const generateState = () => {
  const randomString = (length = 16) => {
    let result = ""
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
    const charactersLength = characters.length
    let counter = 0
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
      counter += 1
    }
    return result
  }
  const state = randomString(16)
  sessionStorage.setItem("authenticity-token", state)
  return state
}

export const getState = () => {
  const state = sessionStorage.getItem("authenticity-token")
  return state
}

export const login = () => {
  if (debug()) console.log("auth.js", "login")
  if (!isBrowser) {
    return
  }
  const state = generateState()
  const auth = getAuth()
  if (debug()) console.log("auth.js", "calling authorize...")
  auth.authorize({ state })
}

export const setSession = (err, authResult) => {
  if (debug()) console.log("auth.js", "setSession")

  if (err) {
    var path = "/"
    if (err.code === "login_required" && isAuthenticated()) {
      if (isBrowser && window.location.pathname.match(/^\/secure/)) {
        path = "/?error=3rd-party-cookies"
      }
    }
    navigate(path)
    return
  }

  if (authResult && authResult.accessToken && authResult.idToken) {
    let expiresAt = authResult.expiresIn * 1000 + new Date().getTime()
    tokens.accessToken = authResult.accessToken
    tokens.idToken = authResult.idToken
    tokens.expiresAt = expiresAt
    user = authResult.idTokenPayload
    sessionStorage.setItem("isLoggedIn", true)
    // sessionStorage.setItem("userRoles", user["https://asterbrands.com/roles"])
    // check client sessionStorage for lastPath, get value, then navigate there or default
    const latestLastPath = sessionStorage.getItem("lastPath")
    latestLastPath ? navigate(latestLastPath) : navigate("/secure/home")
  }
}

export const handleAuthentication = () => {
  if (debug()) console.log("auth.js", "handleAuthentication")
  if (!isBrowser) {
    return
  }
  const auth = getAuth()
  const state = getParam("state")

  auth.parseHash({ hash: window.location.hash, state }, (err, authResult) => {
    if (err) {
      return console.log(err)
    }
    setSession(err, authResult)
  })
}

export const getProfile = () => {
  if (debug()) console.log("auth.js", "getProfile")
  return user
}

export const logout = () => {
  if (debug()) console.log("auth.js", "logout")
  sessionStorage.setItem("isLoggedIn", false)
  const auth = getAuth()
  auth.logout()
}

export const silentAuth = (callback) => {
  if (debug()) console.log("auth.js", "silentAuth")
  if (!authEnabled() || !isAuthenticated()) return callback()
  const auth = getAuth()
  auth.checkSession({}, setSession(callback))
}
